export default __webpack_public_path__ + "static/media/face-5.7dd0ae13.svg";